import { useEffect } from "react";
import { useParams } from "wouter";
import { useLogUsageOnAction } from "@/hooks/useLogUsageOnAction";
import { registerDownloadGate } from "@/lib/downloadGate";

/**
 * Mounted once on a tool's page. Hands the tool page's usage gate to `downloadBlob`, so a tool that saves its
 * result with a plain downloadBlob(...) call is gated the same way DownloadButton is: loading a file and running
 * the tool are free, the day's use is taken (or the pass dialog shown) when the result is saved.
 */
export function DownloadGateRegistrar() {
  const { logUsageNow } = useLogUsageOnAction();
  const params = useParams<{ id?: string }>();
  useEffect(() => {
    registerDownloadGate(params.id ?? null, () => logUsageNow("download"));
    return () => registerDownloadGate(null, null);
  }, [logUsageNow, params.id]);
  return null;
}
